import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { branchValidationForm } from "../../utils/validationSchema";
import BranchForm from "./BranchForm";
import Form from "../../layouts/Form";

const CreateBranch = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(branchValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <BranchForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
      />
    </Form>

  );
};

export default CreateBranch;
